/* eslint-disable @typescript-eslint/no-explicit-any */
import { NotificationState } from "@/store/modules/notification.ts";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import Successful from "@/assets/lotties/successful.json";
import Error from "@/assets/lotties/error.json";

export type NotificationModalType = {
  show?: boolean;
  onClose: () => void;
  type: "error" | "success";
  title: string;
  body: string;
};
export default function NotificationModal({
  show,
  onClose,
  title,
  body,
}: NotificationModalType) {
  const notificationState = useSelector<any>(
    (state) => state.notification
  ) as NotificationState;

  console.log("body: ", body);
  return (
    <>
      {show && (
        <div className="modal-overlay">
          <div className="modal">
            <div className={"success-modal"}>
              {notificationState.modal.type === "error" ? (
                <div className={"success-modal-img"}>
                  {/*<img src={errorImg} width={70} height={70} alt=""/>*/}
                  <Lottie
                    animationData={Error}
                    style={{ width: "100px", height: "100px" }}
                    loop={true}
                  />
                </div>
              ) : (
                <div className={"success-modal-img"}>
                  <Lottie
                    animationData={Successful}
                    style={{ width: "100px", height: "100px" }}
                    loop={true}
                  />
                  {/*<img src={successImg} width={70} height={70} alt=""/>*/}
                </div>
              )}
              <div className={"success-modal-text"}>
                <p className={"modal-title"}>{title}</p>
                <p className={"modal-body"}>{body}</p>
                <div className={"success-modal-btn"}>
                  <button onClick={onClose} className={"continue-btn"}>
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
